export default "<div class=\"errors\">\r\n    <ul>\r\n        <li *ngFor=\"let error of errors\">{{ error.message }}</li>\r\n    </ul>\r\n</div>"